import InputEmail from './email'
import InputText from './text'
import InputPhone from './phone'
import InputNumber from './number'
import InputPassword from './password'
import InputCurrency from './currency'


export { InputText, InputPhone, InputEmail, InputNumber, InputPassword, InputCurrency }
